module.exports = __webpack_public_path__ + "static/media/1870020.34378510.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/elections/us/GeoData/1870020.geojson
// module id = 396
// module chunks = 0